import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Accordion from 'react-bootstrap/Accordion';
import Nav from 'react-bootstrap/Nav';
import { VscFolderActive } from 'react-icons/vsc';
import { FaChartLine, FaHandshake, FaCalendarAlt } from 'react-icons/fa';

const DEFAULT_SECTION_ICONS = {
    production_pipeline: FaChartLine,
    partner_performance: FaHandshake,
    client_engagement: FaCalendarAlt,
};

const ReportsSidebar = ({ sidebarConfig = [], selectedReportId, onSelectReport }) => {
    const [activeKey, setActiveKey] = useState([]);

    useEffect(() => {
        const openSections = sidebarConfig
            .filter((section) => Array.isArray(section.reports) && section.reports.length > 0)
            .map((section) => section.id);

        setActiveKey(openSections);
    }, [sidebarConfig]);

    return (
        <Container fluid className="p-0" style={{ height: '100%' }}>
            <Row className="tf-section-container ms-4 me-0 p-0" style={{ height: '100%' }}>
                <Card style={{ height: '100%' }}>
                    <Card.Body className="p-0 pt-1">
                        <Card.Title className="pt-1 px-3">
                            <Row>
                                <Col className="d-flex align-items-center">
                                    <VscFolderActive />
                                    <span className="ps-2 fw-bold fs-6">Reports</span>
                                </Col>
                            </Row>
                        </Card.Title>

                        <Row>
                            <Col className="px-0">
                                <Accordion activeKey={activeKey} onSelect={setActiveKey} alwaysOpen>
                                    {sidebarConfig.map((section) => {
                                        const reports = Array.isArray(section.reports) ? section.reports : [];
                                        const Icon =
                                            section.icon ||
                                            DEFAULT_SECTION_ICONS[section.id] ||
                                            null;

                                        if (!reports.length) {
                                            return null;
                                        }

                                        return (
                                            <Accordion.Item
                                                eventKey={section.id}
                                                key={`report-section-${section.id}`}
                                            >
                                                <Accordion.Header>
                                                    <div className="d-flex flex-column align-items-start">
                                                        <div className="d-flex align-items-center">
                                                            {Icon ? <Icon className="me-2" /> : null}
                                                            <span className="fw-semibold">
                                                                {section.header}
                                                            </span>
                                                        </div>

                                                        {section.description ? (
                                                            <small className="text-muted fw-normal mt-1">
                                                                {section.description}
                                                            </small>
                                                        ) : null}
                                                    </div>
                                                </Accordion.Header>

                                                <Accordion.Body className="p-0">
                                                    <Nav className="flex-column">
                                                        {reports.map((report) => (
                                                            <Nav.Link
                                                                key={`report-${report.id}`}
                                                                active={report.id === selectedReportId}
                                                                onClick={() => onSelectReport(report)}
                                                                className="ps-4 py-2 small"
                                                            >
                                                                <div className="d-flex flex-column">
                                                                    <span>{report.title}</span>
                                                                    {report.description ? (
                                                                        <small className="text-muted">
                                                                            {report.description}
                                                                        </small>
                                                                    ) : null}
                                                                </div>
                                                            </Nav.Link>
                                                        ))}
                                                    </Nav>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        );
                                    })}
                                </Accordion>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            </Row>
        </Container>
    );
};

const mapProps = (state) => ({
    orgId: state.user.orgId,
    aid: state.user.aid,
    uid: state.user.email,
    user: state.user,
    grids: state.user.meta.datagrids,
    viewing: state.user.viewing,
    canExport: state.user.canExport,
    stack: state.user.stack,
    loans: state.loans.byId,
    contacts: state.contacts.byId,
    tasks: state.tasks.byId,
    notes: state.notes.byId,
    status: state.user.meta.loan.picklist.status,
});

const mapDispatch = (dispatch) => ({
    setDatagridWidth: dispatch.user.setDatagridWidth,
    setDatagridOrder: dispatch.user.setDatagridOrder,
});

export default connect(mapProps, mapDispatch)(ReportsSidebar);